import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

// Elements
import Showcase from 'components/elements/Showcase'

// Third Party
import styled from 'styled-components'

const StyledOtherNews = styled.div``

const OtherNews = ({ className, id }) => {
  const {
    posts: {
      nodes: posts
    }
  } = useStaticQuery(graphql`{
    posts: allWordpressPost {
      nodes {
        ...NewsPreviewFrag
      }
    }
  }`)

  const filteredPosts = posts.filter(p => p.wordpress_id !== id).slice(0, 2)

  return (
    <StyledOtherNews className={`container ${className ? `${className}` : ``}`}>
      <div className="row">
        {filteredPosts.map(p => (
          <div className="col-lg-6" key={p.wordpress_id}>
            <Showcase showcase={p} />
          </div>
        ))}
      </div>
    </StyledOtherNews>
  )
}

export default OtherNews